/* import __COLOCATED_TEMPLATE__ from './article-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();